var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkelmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.227 8.43A10.703 10.703 0 007.592.64l.091-.383c.081-.343.57-.343.652 0l.09.383a10.703 10.703 0 007.366 7.79c.3.09.3.514 0 .603a10.703 10.703 0 00-7.366 7.79l-.09.383c-.082.343-.57.343-.652 0l-.09-.382a10.703 10.703 0 00-7.366-7.79.315.315 0 010-.604z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkelmin);
export default __webpack_public_path__ + "static/media/sparkel.min.750a5251bff836c00bff50622cbb372f.svg";
export { ForwardRef as ReactComponent };